<!--
  - Copyright (c) 2008-2021 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->
<script>
import { EventBus } from "~/common/src/event-bus"

export default {
  /**
   * Global mixin used by the central Vue instance in main.js. You probably don't want to use this plugin in your
   * component - instead you may want to have a look at WindowResizeListenerMixin.
   */
  name: "WindowResizeMixin",

  created() {
    window.addEventListener("resize", this.resized)
  },

  destroyed() {
    window.removeEventListener("resize", this.resized)
  },

  methods: {
    resized() {
      EventBus.$emit("window:resized")
    },
  },
}
</script>
